/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-59
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_172 from /* 172 */"./172"
var eh = [
  {
    type: "WidgetTitle",
    hasDisableOrVisible: true
  }, [
    {
      type: "VisibleSwitch"
    }, {
      type: "DisabledSwitch"
    }
  ], {
    type: "BackgroundColor"
  }, {
    type: "WidgetOpacity"
  }, {
    type: "Coordinate"
  }, {
    type: "Size",
    sizeRange: [[Module_172.k, Module_172.i], [Module_172.j, Module_172.h]]
  }, {
    type: "ListViewerStyleTemplate"
  }, {
    type: "ListNewDataSource"
  }, {
    type: "HelpUrl",
    url: "https://codemao-guide.yuque.com/bfiekm/sbo5kh/list-viewer"
  }
]
export { eh }
